// extracted by mini-css-extract-plugin
export default {"buttonContainer":"DbWXU","alignToEdge":"mjhPI","buttonIcon":"t6WyV","buttonCaption":"Titli","buttonSpacer":"eW1F8"};